import React from "react"

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

export interface FilterOption {
  value: string
  label: string
}

export interface FilterSelectProps {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  placeholder: string
  allLabel: string
  options: FilterOption[]
}

/**
 * Reusable filter select component for compliance filters
 */
export const FilterSelect: React.FC<FilterSelectProps> = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  allLabel,
  options,
}) => {
  return (
    <div className="space-y-1.5">
      <label htmlFor={id} className="text-xs font-medium text-palette-jungleGreen700">
        {label}
      </label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger id={id} className="w-full h-9">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{allLabel}</SelectItem>
          {options.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
